import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { Center } from '@chakra-ui/react'

import { getCurrentUser } from 'redux/actions/user.actions'
import { getAccountData } from 'redux/actions/account.actions'

import AppRoutes from '_routes/AppRoutes'
import PageLoading from '_components/PageLoading'
import AppWrapper from '_layout/AppWrapper'

const useComponentDidMount = ({ user, account, getCurrentUser, getAccountData }) => {
  useEffect(() => {
    if (user && !user.data) {
      getCurrentUser()
    } else if (user.data && user.id && user.data.isAccountActive && account.data === null) {
      getAccountData()
    }
  })
}

const AppNormal = ({ pathname, user, account, getCurrentUser, getAccountData }) => {
  useComponentDidMount({ user, account, getCurrentUser, getAccountData })
  if (!user?.dataHasBeenLoaded || !pathname) {
    return <Center h="100vh"><PageLoading /></Center>
  }
  if (!user.isLoggedIn) {
    return <Redirect to="/" />
  }

  if (!user.data?.isAccountActive && !pathname.startsWith('/plans')) {
    return <Redirect to="/plans" />
  }

  return (
    <AppWrapper>
      <AppRoutes />
    </AppWrapper>
  )
}

const mapStateToProps = state => {
  const { user, account } = state
  return {
    user,
    account
  }
}

export default connect(mapStateToProps, {
  getCurrentUser,
  getAccountData
})(AppNormal)
